import dynamic from 'next/dynamic'

export const FundingSkipAction = dynamic(() => import('./funding-skip-action'))
